import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { theme } from "samba-ui";
import { ThemeProvider } from "styled-components";
import "./index.css";
import Cookies from "js-cookie";
import Auth0 from "./auth0";

import { BrowserRouter as Router } from "react-router-dom";
import "normalize.css";

import configureStore from "./store";
import App from "./App";
import UnauthorizedApp from "./components/UnauthorizedApp";
const accessToken = Cookies.get("accessToken");
const store = configureStore();

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <ThemeProvider theme={theme.v2}>
        {accessToken ? <App /> : <UnauthorizedApp auth={new Auth0()} />}
      </ThemeProvider>
    </Provider>
  </Router>,
  document.getElementById("root")
);
